import styled from "styled-components";

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: space-between;
  border-right: 1px solid ${({ theme }) => theme.border.black10};
  min-width: 210px;
  padding: 24px 16px;
  background-color: ${({ theme }) => theme.bg.primary};
  gap: 16px;
  flex-shrink: 0;
  z-index: 30;

  * {
    font-family: "PP Formula";
  }
`;

export const SidebarItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
  flex: 1;
`;

export const SidebarBottomItemsContainer = styled.div`
  margin-top: auto;
  padding-top: 16px;

  @media (max-height: 780px) {
    border-top: 1px solid ${({ theme }) => theme.border.black15};
  }
`;

export const Spacer = styled.div`
  width: 100%;
  min-height: 20px;
  max-height: 20px;
`;

export const SidebarItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  color: ${({ theme }) => theme.text.text};
  background-color: ${({ theme, isActive = false }) =>
    isActive ? theme.bg.hover : "inherit"};
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme, isActive = false }) =>
      isActive ? theme.bg.hover : theme.border.black10};
  }
`;

export const SidebarItemLabel = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.text.text};
`;
